<table>
    <tr *ngFor="">
        <td></td>
    </tr>
</table>